import React, { ReactNode } from "react";

interface WrapperProps {
  children: ReactNode;
}

const CenterItem: React.FC<WrapperProps> = ({ children }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        justifyContent: "center",
      }}
    >
      {children}
    </div>
  );
};

export default CenterItem;
